
import { inject, Injectable, DOCUMENT } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class CanonicalLinkService {
    private document = inject(DOCUMENT)

    public setUrl(url: string): void {
        let link: HTMLLinkElement | null = this.document.querySelector('link[rel="canonical"]');

        if (!link) {
            link = this.document.createElement('link')
            link.setAttribute('rel', 'canonical')
            this.document.head.appendChild(link)
        }

        link.setAttribute('href', url)
    }
}